import { render, staticRenderFns } from "./pdfViewer.vue?vue&type=template&id=fd7f27c0&scoped=true"
import script from "./pdfViewer.vue?vue&type=script&lang=js"
export * from "./pdfViewer.vue?vue&type=script&lang=js"
import style0 from "./pdfViewer.vue?vue&type=style&index=0&id=fd7f27c0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd7f27c0",
  null
  
)

export default component.exports